module.exports = __webpack_public_path__ + "img/MO.444e223e.svg";